<template>
    <div class="slide-down iconfont icon-jiantou_yemian_xiangxia" v-show="slideDown"></div>
</template>

<script>
export default {
    name: "SlideDown",
    data() {
        return {
            slideDown: false,
            indexName: '',
        };
    },
    created() {
        const THAT = this;
        THAT.indexName = THAT.$router.history.current.name;
        /**
         * 首页：Index、Home
         * 二阶段： Vote、MVote
         * 三阶段： Formula、MFormula
         *  */
        if (THAT.indexName == 'Index' || THAT.indexName == 'Home' || THAT.indexName == 'Vote' || THAT.indexName == 'MVote' || THAT.indexName == 'Formula' || THAT.indexName == 'MFormula') {
            THAT.slideDown = true;
        } else {
            THAT.slideDown = false;
        }
    },
    mounted() {
        const THAT = this;
        THAT.handleScroll();
        window.addEventListener('scroll', THAT.handleScroll, true);
    },
    methods: {
        handleScroll() {
            const THAT = this;
            var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.getElementById('app').scrollTop;
            if (scrollTop >= 1) THAT.slideDown = false;
            if (scrollTop == 411 && THAT.indexName == 'Index') THAT.slideDown = true;
        },
    },
};
</script>

<style lang="scss" scoped>
.slide-down {
    position: fixed;
    left: 50%;
    bottom: 0;
    margin-left: -50px;
    z-index: 100;
    width: 100px;
    font-size: 58px;
    text-align: center;
    color: #2afcf5;
    transition: all .5s;
    animation: toDownAni 2s infinite linear;
}

@keyframes toDownAni {
    0% {
        transform: translateY(-200px);
        opacity: 0;
    }

    100% {
        transform: translateY(0);
        opacity: 1;
    }
}
</style>



// WEBPACK FOOTER //
// src/plugin/SlideDown.vue